import { routes } from "./routes";

export const environment = {
  production: false,
  hmr: false,
  build: 8.8,
  keys: {
    token: 'TOKEN_PROXY_KEY',
    refreshToken: 'REFRESH_TOKEN_PROXY_KEY',
    user: 'USER_PROXY_KEY',
    forceSubdomain: '@uni/force-subdomain',
  },
  config: {
    redirectToWhenAuthenticated: '/pages/dashboard',
    redirectToWhenUnauthenticated: '/auth/login',
    maxVideoSizeInMb: 200,
    autoRefreshInterval: 10000,
    domain: 'https://backoffice-dev.gemeodigital.unicorporativa.com',
    staticSite: 's3.us-east-1.amazonaws.com/files-static-dev.gemeodigital.unicorporativa.com/',
    facens: {
      loginUrl: 'https://auth.facens.ligafacens.com/authorize?response_type=code&redirect_uri={redirectUri}&client_id={clientId}',
      clientId: '8aefb238-e129-4b06-aef0-0122c68e7771',
      redirectUrl: 'https://backoffice-dev.gemeodigital.unicorporativa.com/oauth2',
    },
  },
  api: {
    baseUrl: 'https://api-dev.gemeodigital.unicorporativa.com',
    routes,
    auth: {
      login: '/auth/local',
      newtonLogin: '/newton/bo',
    },
    users: {
      me: '/users/me',
    },
  },
};
